import moment from 'moment';
import { EChartsOption } from 'echarts';
import { ChartDataSeries, dataViewFormatter, getTimestampedFileNameForWidget, RowData } from '../helpers/widgets';
import { ToolboxComponentOption } from 'echarts';
import { analytesForWeather } from '@app/client/clients/wastemanagement/taiao-dashboard-layout/charts.config';
import { data } from 'jquery';

interface WeatherData {
  date: Date;
  rain: number;
  wind: string;
}

const formatDate = (date: Date): string => {
  return moment(date).format('YYYY-MM-DD');
};

const displayDate = (date: Date): string => {
  return moment(date).format('DD/MM/YYYY');
};

/**
 * Renders a cell in the weather data table.
 *
 * @param series The data series for the cell.
 * @param cellValue The data point for the cell.
 * @returns The HTML string for the cell.
 */
const weatherCellRenderer = (series: ChartDataSeries, cellValue?: RowData): string => {
  const value = cellValue;
  const formatted = Number(value).toFixed(2);

  return String(formatted);
};

/**
 * Gets the unit label for a given title case string.
 *
 * @param titleCase The title case string to match against known analytes.
 * @returns
 */
const getTitleUnitLabel = (titleCase: string) => {
  let unit: string = '';

  const match = analytesForWeather.find((a: any) => {
    const aName = String(a?.name ?? '').trim();
    return aName && aName.toLowerCase() === titleCase.toLowerCase();
  });

  unit = match?.unit ? match?.unit : '';

  return unit;
};

const getChartConfig = (chartOptions: EChartsOption, data: WeatherData[], fileName: string) => {
  return {
    ...chartOptions,
    toolbox: {
      ...chartOptions.toolbox,
      feature: {
        ...(<ToolboxComponentOption>chartOptions.toolbox)?.feature,
        dataView: {
          show: true,
          readOnly: true,
          optionToContent: (option: any): string | HTMLElement =>
            dataViewFormatter(option as EChartsOption, weatherCellRenderer, getTitleUnitLabel),
        },
        saveAsImage: {
          show: true,
          name: getTimestampedFileNameForWidget(fileName),
        },
      },
    },
    xAxis: [
      {
        ...(Array.isArray(chartOptions.xAxis) ? chartOptions.xAxis[0] : {}),
        data: data.map((item: WeatherData) => displayDate(item.date)),
      },
    ],
    series: [
      {
        ...(Array.isArray(chartOptions.series) ? chartOptions.series[0] : {}),
        data: data.map((item: WeatherData) => item.rain),
      },
      {
        ...(Array.isArray(chartOptions.series) && chartOptions.series[1] ? chartOptions.series[1] : {}),
        data: data.map((item: WeatherData) => parseFloat(item.wind)),
      },
    ],
  };
};

export { formatDate, getChartConfig };
